import { render, staticRenderFns } from "./spot_space_order.vue?vue&type=template&id=a8f86aca&scoped=true&"
import script from "./spot_space_order.vue?vue&type=script&lang=js&"
export * from "./spot_space_order.vue?vue&type=script&lang=js&"
import style0 from "./spot_space_order.vue?vue&type=style&index=0&id=a8f86aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f86aca",
  null
  
)

export default component.exports